import roomTypes from './roomTypes.js'

function parseRoomAllocation (roomAllocation) {
  var re = /(\d+)x(.*)/

  var match = re.exec(roomAllocation)

  if (match) {
    var count = match[1]
    var roomType = match[2]

    return {
      roomType: roomTypes.typeNameForCode(roomType),
      count: parseInt(count),
    }
  }

  return null
}

export const parse = function (string) {
  if (string) {
    var roomAllocationsByKey = {}
    var roomAllocationKeys = string.split('-')
    roomAllocationKeys.forEach(key => {
      if (roomAllocationsByKey[key]) {
        roomAllocationsByKey[key].count++
      } else {
        roomAllocationsByKey[key] = parseRoomAllocation(key)
      }
    })

    var roomAllocationsCollection = Object.keys(roomAllocationsByKey)
      .map(key => roomAllocationsByKey[key])
      .filter(el => el !== null)
    if (roomAllocationsCollection.length === 0) roomAllocationsCollection = null

    return roomAllocationsCollection
  } else {
    return []
  }
}

export const stringify = function (roomAllocations = [], sorted = false) {
  var distinctRoomTypes = []
  roomAllocations.forEach(function (room) {
    var existing = distinctRoomTypes.find(r => r.roomType == room.roomType)
    if (existing) {
      existing.count += room.count || 1
    } else {
      room.count = room.count || 1
      distinctRoomTypes.push({
        roomType: room.roomType,
        count: room.count,
      })
    }
  })
  if (sorted) {
    distinctRoomTypes = distinctRoomTypes.sort((a, b) => {
      return a.roomType.localeCompare(b.roomType)
    })
  }
  return distinctRoomTypes
    .map(
      room => `${room.count || 1}x${roomTypes.codeForTypeName(room.roomType)}`
    )
    .join('-')
}
